import { checkIsAutomatedBrowser } from '@/bot-detection/checkIsAutomatedBrowser.ts';
import { state } from './state.ts';

export function getInfo() {
  return {
    get automatedBrowserState() {
      return checkIsAutomatedBrowser();
    },
    get session() {
      return {
        ...state.currentSession,
      };
    },
    get playgroundMode() {
      return state.playgroundMode;
    },
    get userId() {
      return state.userId;
    },
    get userUUId() {
      return state.userUUId;
    },
    get activeExperiments() {
      return [...state.activeExps.entries()].reduce((map, [key, value]) => {
        return {
          ...map,
          [key]: value,
        };
      }, {});
    },
    get activeFlags() {
      return [...state.activeFlags];
    },
    get activeSurveys() {
      return state.activeSurveys.map(e => e.id);
    },
  };
}
